import { render, staticRenderFns } from "./ObjectArchive.vue?vue&type=template&id=0b20b709&scoped=true&"
import script from "./ObjectArchive.vue?vue&type=script&lang=js&"
export * from "./ObjectArchive.vue?vue&type=script&lang=js&"
import style0 from "./ObjectArchive.vue?vue&type=style&index=0&id=0b20b709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b20b709",
  null
  
)

export default component.exports